var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6187 23.1746L23.4816 14.3117C25.6593 12.134 25.9806 8.55139 23.9198 6.2628C23.4036 5.68788 22.7756 5.22417 22.0743 4.89996C21.3729 4.57575 20.6129 4.39783 19.8405 4.37706C19.0682 4.35629 18.2996 4.4931 17.5819 4.77915C16.8641 5.06521 16.2122 5.4945 15.6658 6.04084L14 7.70666L12.5617 6.26839C10.384 4.09068 6.80139 3.7694 4.5128 5.83024C3.93788 6.34645 3.47417 6.97438 3.14996 7.67572C2.82575 8.37706 2.64783 9.13711 2.62706 9.90948C2.60629 10.6819 2.7431 11.4504 3.02915 12.1681C3.31521 12.8859 3.7445 13.5378 4.29084 14.0842L13.3813 23.1746C13.5454 23.3387 13.7679 23.4309 14 23.4309C14.2321 23.4309 14.4546 23.3387 14.6187 23.1746V23.1746Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIconWhite);
export default __webpack_public_path__ + "static/media/love-icon-white.2b40e0aa814b1126154d956f8c741813.svg";
export { ForwardRef as ReactComponent };